/**
 * @file contains all the form input ids used
 */

export const ACCORDION__TRIGGER = 'ACCORDION__TRIGGER';
export const ACCORDION__CONTENT = 'ACCORDION__CONTENT';

export const ASSIGNMENT__EDIT__HEADING = 'ASSIGNMENT__EDIT__HEADING';

export const ATTACHMENT__EDIT__HEADING = 'ATTACHMENT__EDIT__HEADING';

export const CHECKBOX = 'CHECKBOX';

export const CHECKLIST__ADD__FORM = 'CHECKLIST__ADD__FORM';
export const CHECKLIST__ADD__HEADING = 'CHECKLIST__ADD__HEADING';
export const CHECKLIST__ADD__SUBHEADING = 'CHECKLIST__ADD__SUBHEADING';
export const CHECKLIST__EDIT__HEADING = 'CHECKLIST__EDIT__HEADING';

export const COMPOSE__FORM_ID = 'COMPOSE__FORM_ID';

export const DATE_DUE__EDIT__DESCRIPTION = 'DATE_DUE__EDIT__DESCRIPTION';
export const DATE_DUE__EDIT__FORM = 'DATE_DUE__EDIT__FORM';
export const DATE_DUE__EDIT__HEADING = 'DATE_DUE__EDIT__HEADING';

export const GENERAL__INPUT = 'GENERAL__INPUT';

export const GROUP__ASSIGN__FORM_ID = 'GROUP__ASSIGN__FORM_ID';
export const GROUP__CREATE__FORM_ID = 'GROUP__CREATE__FORM_ID';

export const HOTEL_CHANGE__SELECT_ID = 'HOTEL_CHANGE__SELECT_ID';

// Label edit form
export const LABEL__EDIT__FORM = 'LABEL__EDIT__FORM';
export const LABEL__EDIT__HEADING = 'LABEL__EDIT__HEADING';

export const LOADING__MESSAGES = 'LOADING__MESSAGES';
export const LOADING__TOPIC_BASIC = 'LOADING__TOPIC_BASIC';

export const MESSAGE_STATUS__SELECT_ID = 'MESSAGE_STATUS__SELECT_ID';

export const MESSAGE__CONCIERGE_TOGGLE = 'MESSAGE__CONCIERGE_TOGGLE';
export const MESSAGE__INFO__ASSIGNEE = 'MESSAGE__INFO__ASSIGNEE';
export const MESSAGE__INFO__CHECKLIST = 'MESSAGE__INFO__CHECKLIST';
export const MESSAGE__INFO__DUE_DATE = 'MESSAGE__INFO__DUE_DATE';
export const MESSAGE__INFO__STATUS = 'MESSAGE__INFO__STATUS';
export const MESSAGE__STYLING_TOGGLE = 'MESSAGE__STYLING_TOGGLE';

// Message create forms
export const MESSAGE__CREATE__TEXT_FORM = 'MESSAGE__CREATE__TEXT_FORM';
export const MESSAGE__CREATE__TITLE_FORM = 'MESSAGE__CREATE__TITLE_FORM';

// Message edit forms
export const MESSAGE__EDIT__TEXT_FORM = 'MESSAGE__EDIT__TEXT_FORM';
export const MESSAGE__EDIT__TITLE_FORM = 'MESSAGE__EDIT__TITLE_FORM';
export const MESSAGE__EDIT__TITLE_AND_TEXT_FORM =
  'MESSAGE__EDIT__TITLE_AND_TEXT_FORM';
export const MESSAGE__EDIT__TEXT_HEADING = 'MESSAGE__EDIT__TEXT_HEADING';
export const MESSAGE__EDIT__TITLE_HEADING = 'MESSAGE__EDIT__TITLE_HEADING';
export const MESSAGE__EDIT__TITLE_AND_TEXT_HEADING =
  'MESSAGE__EDIT__TITLE_HEADING';
export const MESSAGE__TEXT_UPDATE_ID = 'MESSAGE__TEXT_UPDATE_ID';
export const MESSAGE__TITLE_UPDATE_ID = 'MESSAGE__TITLE_UPDATE_ID';

export const MODAL__BUTTON_BACK__ID = 'BUTTON_BACK__ID';

export const MODAL__GROUP_ASSIGN__LABEL = 'MODAL__GROUP_ASSIGN__LABEL';
export const MODAL__GROUP_ASSIGN__DESCRIPTION =
  'MODAL__GROUP_ASSIGN__DESCRIPTION';
export const MODAL__GROUP_CREATE__LABEL = 'MODAL__GROUP_CREATE__LABEL';
export const MODAL__GROUP_CREATE__DESCRIPTION =
  'MODAL__GROUP_CREATE__DESCRIPTION';

export const MODAL__LABEL_CREATE__LABEL = 'MODAL__LABEL_CREATE__LABEL';
export const MODAL__LABEL_CREATE__DESCRIPTION =
  'MODAL__LABEL_CREATE__DESCRIPTION';
export const MODAL__LABEL_UPDATE__LABEL = 'MODAL__LABEL_UPDATE__LABEL';
export const MODAL__LABEL_UPDATE__DESCRIPTION =
  'MODAL__LABEL_UPDATE__DESCRIPTION';

export const MODAL__NOTIFICATIONS__HEADING = 'MODAL__NOTIFICATIONS__HEADING';
export const MODAL__NOTIFICATIONS__SUBHEADING =
  'MODAL__NOTIFICATIONS__SUBHEADING';

export const MODAL__RESOURCE_ARCHIVE__LABEL = 'MODAL__RESOURCE__ARCHIVE_LABEL';
export const MODAL__RESOURCE_ARCHIVE__DESCRIPTION =
  'MODAL__RESOURCE__ARCHIVE__DESCRIPTION';

export const MODAL__RESOURCE_DELETE__LABEL = 'MODAL__RESOURCE__DELETE_LABEL';
export const MODAL__RESOURCE_DELETE__DESCRIPTION =
  'MODAL__RESOURCE__DELETE__DESCRIPTION';

export const MODAL__TOPIC_ASSIGN__LABEL = 'MODAL__TOPIC_ASSIGN__LABEL';
export const MODAL__TOPIC_ASSIGN__DESCRIPTION =
  'MODAL__TOPIC_ASSIGN__DESCRIPTION';
export const MODAL__TOPIC_CREATE__LABEL = 'MODAL__TOPIC_CREATE__LABEL';
export const MODAL__TOPIC_CREATE__DESCRIPTION =
  'MODAL__TOPIC_CREATE__DESCRIPTION';
export const MODAL__TOPIC_UPDATE__LABEL = 'MODAL__TOPIC_UPDATE__LABEL';
export const MODAL__TOPIC_UPDATE__DESCRIPTION =
  'MODAL__TOPIC_UPDATE__DESCRIPTION';

export const MODAL__USER_UPDATE__LABEL = 'MODAL__USER_UPDATE__LABEL';
export const MODAL__USER_UPDATE__DESCRIPTION =
  'MODAL__USER_UPDATE__DESCRIPTION';
export const MODAL__USER_UPDATE__SELECT = 'MODAL__USER_UPDATE__SELECT';

export const QUICK__SELECTION__TITLE = 'QUICK__SELECTION__TITLE';

export const REMINDER__ADD__HEADING = 'REMINDER__ADD__HEADING';

export const TAB = 'TAB';
export const TAB__PANEL = 'TAB__PANEL';

export const TEMPLATE_TOPIC__EDIT__HEADING = 'TEMPLATE_TOPIC__EDIT__HEADING';

export const TEMPLATE_RECURRING__FORM = 'TEMPLATE_RECURRING__FORM_ID';
export const TEMPLATE_RECURRING__HEADING = 'TEMPLATE_RECURRING__HEADING';
export const TEMPLATE_RECURRING__INTERVAL__INPUT =
  'TEMPLATE_RECURRING__INTERVAL__INPUT';
export const TEMPLATE_RECURRING__RADIO = 'TEMPLATE_RECURRING__RADIO';
export const TEMPLATE_RECURRING__RADIO__MONTH =
  'TEMPLATE_RECURRING__RADIO__MONTH';
export const TEMPLATE_RECURRING__SELECT__BYSETPOS =
  'TEMPLATE_RECURRING__SELECT__BYSETPOS';
export const TEMPLATE_RECURRING__SELECT__BYWEEKDAY =
  'TEMPLATE_RECURRING__SELECT__BYWEEKDAY';

export const TOPIC__ASSIGN__FORM_ID = 'TOPIC__ASSIGN__FORM_ID';
export const TOPIC__CREATE__FORM_ID = 'TOPIC__CREATE__FORM_ID';
export const TOPIC__UPDATE__FORM_ID = 'TOPIC__UPDATE__FORM_ID';
export const TOPIC__TITLE_UPDATE_ID = 'TOPIC__TITLE_UPDATE_ID';
export const TOPIC__DESCRIPTION_UPDATE_ID = 'TOPIC__DESCRIPTION_UPDATE_ID';

export const USER__EDIT__FORM = 'USER__EDIT__FORM';
